import { h } from "@stencil/core";

interface DynamicStylesProps {
    uniqueId: string;
    fixedColWidth: number;
    maxFixedColWidth: number;
    fixedClass: string;
    fixedColIndex: number;
    equalColumnWidth: boolean;
    fixedColumnHasMinWidth: boolean;
    table: HTMLTableElement;
}

export const DynamicStyles = ({
    uniqueId,
    fixedColWidth,
    maxFixedColWidth,
    fixedClass,
    fixedColIndex,
    equalColumnWidth,
    fixedColumnHasMinWidth,
    table
}: DynamicStylesProps) => {
    const fixedCol = fixedColIndex + 1; // CSS selectors work with an 1-based index
    const lastRow = table.rows[table.rows.length - 1];
    const lastCellIndex = lastRow.cells[lastRow.cells.length - 1].cellIndex;
    const columnCount = table.rows[0].cells.length;
    return (
        <style>{`
            #${uniqueId} th:nth-child(${fixedCol}),
            #${uniqueId} td:nth-child(${fixedCol}) {
                max-width: ${maxFixedColWidth}px;
            }

            .${fixedClass} #${uniqueId} th:nth-child(${fixedCol}),
            .${fixedClass} #${uniqueId} td:nth-child(${fixedCol}) {
                position: absolute;
                left: 0;
                width: ${fixedColWidth}px;
                min-width: ${fixedColumnHasMinWidth ? `fit-content` : `auto`};
                display:flex;
                align-items: center;
                justify-content: flex-start;
                border-left: 1px solid transparent;
            }

            .${fixedClass} #${uniqueId} th:nth-child(${fixedCol}) {
                border-right: 1px solid #9ea9b0;
            }

            .${fixedClass} #${uniqueId} td:nth-child(${fixedCol}) {
                border-top: 1px solid transparent;
                border-right: 1px solid #cbcbcb;
            }

            .${fixedClass} #${uniqueId} th:nth-child(${lastCellIndex === fixedColIndex ? lastCellIndex : 0}),
            .${fixedClass} #${uniqueId} td:nth-child(${lastCellIndex === fixedColIndex ? lastCellIndex : 0}) {
                border-right: 1px solid transparent !important;
            }

            .${fixedClass} #${uniqueId} table {
                margin-left: ${fixedColWidth}px;
            }

            #${uniqueId}:before {
                left: ${fixedColWidth}px;
            }

            ${
                equalColumnWidth
                    ? `#${uniqueId} td {
                    width: ${100 / columnCount}%;
                }`
                    : ""
            }
        `}</style>
    );
};
